/**
*  Copyright (c) 2020 Micro Focus Software Inc.  All Rights Reserved.
*
* THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
* AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
* WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
* TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
* AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
* INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
* PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
* CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
* OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
* ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
* THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
*/

import { Component, Input, OnInit, OnChanges, OnDestroy } from '@angular/core';
import { RequestDetailService } from '../services/request-detail.service';
import { RequestDetailResponse, CustomFormField } from '../model/requestdetailresponse';
import { RequestlistSearchService } from '../services/requestlist-searchservice';
import { RequestNotes } from '../model/requestnotesresponse';
import { RequestInfo } from '../model/requestinforesponse';
import { RequestCustomFieldInfo } from '../model/requestcustomfieldinforesponse';
import { DomSanitizer } from '@angular/platform-browser';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Observable, BehaviorSubject, Subscription } from 'rxjs';
import { ClientInfo, CustomerSearchInfoResponse } from '../model/clientinfo';
import { FormControl } from '@angular/forms';
import { RequestUpdateInfo, Actions } from '../model/requestupdateinfo';
import { SpinnerService } from '../../../../shared/spinner/spinner.service';
import { AlertMessage } from '../../../../shared/alert/alertmessage';
import { AlertService } from '../../../../shared/alert/alert.service';
import { RequestslistService } from '../services/requestslist.service';
import { RequestBasicInfoResultEntity } from '../model/requestslistresponse';
import { CustomerPreferenceService } from '../../../preference/customerpreference.service';
import { UserProfileService } from '../../../view/userprofile/userprofile.service';
import { UserProfileResponse } from '../../../view/userprofile/userprofileresponse';
import { CustomerPreferenceResponse } from '../../../preference/customerpreference.model';
import { RequestsService } from '../services/requests.service';
import { RequestAttachment } from '../model/requestattachmentresponse';
import * as FileSaver from 'file-saver';
import { HttpClient, HttpRequest, HttpEvent, HttpEventType } from '@angular/common/http';
import { CommonConstants } from '../../../../common/constants/common-constants';
import { debounceTime, distinctUntilChanged, tap, switchMap } from 'rxjs/operators';
import { Router } from '@angular/router';
declare var $: any;

@Component({
  selector: 'zsd-requestdetail',
  templateUrl: '../view/requestdetail.component.html',
  styleUrls: ['../view/requestdetail.component.scss'],
})
export class RequestDetailComponent implements  OnInit, OnChanges , OnDestroy {
  requestsDetailsData: Array<any> = [];
  @Input() index: number;
  @Input() detArrIndex: number;
  @Input() selectedAction: Actions;
  @Input() clickedAct: boolean;
  requestDetailsForm: FormGroup;
  maxLength = 350;
  showToggleButton = true;
  public isCollapsed = true;
  currentText: string;
  requestUpdateInfo: RequestUpdateInfo = new RequestUpdateInfo();
  requestDetailResponse: RequestDetailResponse = new RequestDetailResponse();
  requestInfo: RequestInfo = new RequestInfo();
  requestCustomfield = new Array<RequestCustomFieldInfo>();
  customFormField = new Array<CustomFormField>();
  reqNumber: number;
  requestNotesResponse = new Array<RequestNotes>();
  reqNotesAttachmentResponse = new Array<RequestAttachment>();
  matrix = [];
  users: Observable<CustomerSearchInfoResponse>;
  usersLoading = false;
  ccField = new FormControl();
  ccList: ClientInfo[] = new Array();
  validFileList: Array<File> = [];
  fileUploadFormValid: boolean;
  isLoading = false;
  currentLoggedInUserFullName: string;
  showNotify: boolean;
  showTechnician: boolean;
  attachmentIsLoading = false;
  attachmentSpinnerStart = true;

  _requestNo: BehaviorSubject<number> = new BehaviorSubject<number>(null);
  selectedActionSubscription: Subscription;

  currentCcUserIndex = -1;
  ccUserSearchResultCount = 0;
  userSearchCurrentDisplayedCount: number;
  userSearchOffset: number;
  userSearchLimit: number;
  userSearchTerm: string;
  userSearchInfo: CustomerSearchInfoResponse;

  @Input() set requestNumber(value: number) {
    this._requestNo.next(value);
  }

  get requestNumber() {
   return this._requestNo.getValue();
  }

  constructor(public requestDetailService: RequestDetailService, public requestListSearchService: RequestlistSearchService,
    public _DomSanitizer: DomSanitizer, public formBuilder: FormBuilder, public spinnerService: SpinnerService ,
    public alertService: AlertService, public requestListService: RequestslistService, public userProfileService: UserProfileService,
    public customerPreferenceService: CustomerPreferenceService, public requestsService: RequestsService,
    public http: HttpClient, public router: Router) {
      this.subscribeSelectedAction();
  }


  // to set the focus to the tinymce editor
  ngOnChanges(): void {
    if (this.clickedAct) {
      setTimeout(() => {   let element = $('#tinymce'  + this.index);
     let elementHeight = element.height();
     let windowHeight  = $(window).height();
     let offset = Math.min(elementHeight, windowHeight) + element.offset().top - 230;
     $('html, body').animate({ scrollTop: offset }, 500); }, 100);
    }
  }

  ngOnInit() {
  this.reqNumber = this.requestNumber;
  this.getRequestDetails(this.reqNumber);

    this.userProfileService.getUserprofile().subscribe(
      (user: UserProfileResponse) => {
        this.currentLoggedInUserFullName = user.fullName;
      },
      () => {
        return null;
      }
    );
    this.customerPreferenceService
      .getPreferenceList()
      .subscribe((preference: CustomerPreferenceResponse) => {
        this.showNotify = preference.showNotify;
        this.showTechnician = preference.showTechnician;
      },
        () => {
          return null;
        }
      );


  this.requestDetailsForm = this.formBuilder.group({
      cc: this.formBuilder.control({ value: '' })
    });

      this.users = this.ccField.valueChanges.pipe(
        debounceTime(400),
        distinctUntilChanged(),
        // filter((searchTerm) => (searchTerm.length > 1)),
        tap(() => this.usersLoading = true),
        switchMap(searchTerm => {
          this.userSearchTerm = searchTerm;
          return this.requestDetailService.findUser(searchTerm , 0 , 10);
        }),
        tap((resp) => {
          // if (resp) {
          //   this.searchListFlag = true;
          // }
          this.usersLoading = false;
          this.userSearchOffset = 0;
          this.userSearchLimit = 10;
          this.ccUserSearchResultCount = resp.resultCount;
          this.userSearchCurrentDisplayedCount = resp.results.length;
        })
      );

      this.users.forEach((info) => {
        this.userSearchInfo = info;
      });
    }

  ngOnDestroy() {
    this.selectedActionSubscription.unsubscribe();
  }

  addToCCList(selectedUser: ClientInfo) {
    this.ccList.push(selectedUser);
    this.ccField.setValue(null);
    document.getElementById('input-user' + this.index).focus();

    this.currentCcUserIndex = -1;
  }

  removeFromCCList(indexToRemove: number) {
    this.ccList.splice(indexToRemove, 1);
    document.getElementById('input-user' + this.index).focus();
  }

  requestDetailAttachment(i: number) {
    this.attachmentIsLoading = true;
    this.requestListService.getAttachmentDetailsWithNotes(this.reqNumber,
      this.requestNotesResponse[i].noteId).subscribe((requestNotesAttachment: any) => {
      this.reqNotesAttachmentResponse = requestNotesAttachment;
      this.attachmentIsLoading = false;
      this.attachmentSpinnerStart = false;
    });
  }

  ccListKeyPressAction(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;

    // Backspace action, remove last user
    if (charCode === 8 && !this.ccField.value && this.ccList.length > 0) {
      this.ccList.splice(this.ccList.length - 1, 1);
      document.getElementById('input-user' + this.index).focus();
      this.currentCcUserIndex = -1;
    } else if (charCode === 40) { // Key Down action
      event.preventDefault();
      this.currentCcUserIndex++;
      if (this.currentCcUserIndex >= this.userSearchCurrentDisplayedCount) {
        this.currentCcUserIndex = 0;
      }
      let listid = `user${this.currentCcUserIndex}${this.index}`;
      let elmnt = document.getElementById(listid);
      elmnt.scrollIntoView(false);
      $(window).scrollTop($('#requestdetail-form' + this.index).offset().top - 120);

    } else if (charCode === 38) { // Key up action
      event.preventDefault();
      this.currentCcUserIndex--;
      if (this.currentCcUserIndex < 0) {
        this.currentCcUserIndex = (this.userSearchCurrentDisplayedCount - 1);
      }
      let listid = `user${this.currentCcUserIndex}${this.index}`;
      let elmnt = document.getElementById(listid);
      elmnt.scrollIntoView(false);
      $(window).scrollTop($('#requestdetail-form' + this.index).offset().top - 120);
    } else if (charCode === 13) { // Enter action
      event.preventDefault();
      document.getElementById('user' + this.currentCcUserIndex + this.index).click();
    } else {
      this.currentCcUserIndex = -1;
    }

    return true;
  }

  setFocusToCCField() {
    document.getElementById('input-user' + this.index).focus();
  }

  public getUserDisplayString(user: ClientInfo): string {
    if (user.fullName) {
        return user.fullName + '<' + user.email + '>';
    }

    return user.email;
}

  getRequestDetails(requestNumber) {
      this.requestDetailService.getRequestDetail(requestNumber)
        .subscribe((reqDetailResponse: RequestDetailResponse) => {
          this.requestDetailResponse = reqDetailResponse;
          this.requestNotesResponse = reqDetailResponse.requestNotes;
          this.requestInfo = reqDetailResponse.requestInfo;
          this.requestCustomfield = reqDetailResponse.requestCustomFieldInfo;
          this.ccList = this.requestInfo.ccList;
          this.customFormField = reqDetailResponse.customFormFields;
          if (this.validateSource(this.requestInfo.description)) {
            setTimeout(() => {
              this.determineView();
            }, 1);
          }
          if (this.customFormField.length > 0) {
            this.setDataForCustomformFields();
          }
        });
  }
  setDataForCustomformFields() {
          let chunkSize = 2;
          let arr = this.customFormField;
          let groups = arr.map(function (e, i) {
            return i % chunkSize === 0 ? arr.slice(i, i + chunkSize) : null;
            console.log(e);
          });
          this.matrix = groups;
  }

  getRequestDetailsAfterUpdate(requestNumber) {
    this.requestDetailService.getRequestDetail(requestNumber)
      .subscribe((reqDetailResponse: RequestDetailResponse) => {
        this.requestDetailResponse = reqDetailResponse;
          this.requestNotesResponse = reqDetailResponse.requestNotes;
          this.requestInfo = reqDetailResponse.requestInfo;
          this.requestCustomfield = reqDetailResponse.requestCustomFieldInfo;
          this.ccList = this.requestInfo.ccList;
          this.requestListService.publishRequestChanges(this.requestInfo);
        if (this.validateSource(this.requestInfo.description)) {
          setTimeout(() => {
            this.determineView();
          }, 1);
        }
      });
}

  toggleView() {
    this.isCollapsed = !this.isCollapsed;
    this.determineView();
  }

  validateSource(s) {
    if (typeof s !== 'string') {
      return false;
    } else {
      return true;
    }
  }

  updateRequest() {
    if (this.requestDetailsForm.valid && this.fileUploadFormValid) {
      this.isLoading = true;
      this.spinnerService.show();
      this.requestUpdateInfo.note = this.requestDetailsForm.value.tinyMce.tinymce;
      this.requestUpdateInfo.action = this.selectedAction;

      if (this.ccList) {
        let ccListEmail = this.ccList.map(userInfo => userInfo.email);
        this.requestUpdateInfo.customerCC = ccListEmail.join(','); // Make a string of all emails seperated by comma.
      }
      const alertMessage = new AlertMessage();
      this.requestDetailService.updateRequest(this.reqNumber, this.validFileList, this.requestUpdateInfo).subscribe(
        () => {
          alertMessage.type = 'info';
          alertMessage.message = 'Alert.requestUpdated';
          alertMessage.params = this.reqNumber.toString();
          if (this.requestUpdateInfo.action === Actions.APPROVE || this.requestUpdateInfo.action === Actions.REJECT) {
            this.requestInfo.isAwaitingMyApproval = false;
            this.requestListService.publishRequestChanges(this.requestInfo);
          }
          this.isLoading = false;
          this.spinnerService.hide();
          this.getRequestDetailsAfterUpdate(this.reqNumber);
          this.doCleanUp();
          this.requestsService.removeFromEditModeList(this.reqNumber);
        },
        err => {
          this.isLoading = false;
          this.spinnerService.hide();
          alertMessage.message = err.error.localizedMessage;
          alertMessage.type = 'warn';
          this.alertService.displayAlert(alertMessage);
          console.log(err.error.localizedMessage);
        });
        this.alertService.displayAlert(alertMessage);
    } else {
      (this.requestDetailsForm.controls['tinyMce'] as FormGroup).controls['tinymce'].markAsTouched();
    }

  }

  cancelUpdateRequest() {
    this.doCleanUp();
    this.requestsService.removeFromEditModeList(this.reqNumber);
  }

  doCleanUp() {
    this.ccList.splice(0, this.ccList.length);
    this.ccField.setValue(null);
    this.requestDetailService.getRequestDetail(this.requestNumber).subscribe(
      (reqDetailResponse: RequestDetailResponse) => {
          this.ccList = reqDetailResponse.requestInfo.ccList;
      });
    this.selectedAction = null;
    this.requestUpdateInfo = new RequestUpdateInfo();
    this.validFileList = [];
    this.requestDetailsForm = this.formBuilder.group({
      cc: this.formBuilder.control({ value: '' })
    });
  }

  determineView() {
    if (this.requestInfo.description.length <= this.maxLength) {
      this.currentText = this.requestInfo.description;
      this.isCollapsed = false;
      return;
    }

    if (this.isCollapsed === true) {
      this.currentText = this.requestInfo.description.substring(0, this.maxLength) + ' ...';
    } else if (this.isCollapsed === false) {
      this.currentText = this.requestInfo.description;
    }
  }

  selectedFilesList(fileList: Array<File>) {
    this.validFileList = fileList;
  }

  isfileuploadformvalid(formvalid: boolean) {
    this.fileUploadFormValid = formvalid;
  }

  isNoteMandatory() {
    return (this.selectedAction === Actions.ADDNOTE || this.selectedAction === Actions.DEESCALATE
       || this.selectedAction === Actions.ESCALATE || this.selectedAction === Actions.REJECT || this.selectedAction === Actions.REOPEN);
  }

  isNotNoActions() {
    return (this.selectedAction !== Actions.NOACTIONS);
  }

  subscribeSelectedAction() {
    this.selectedActionSubscription = this.requestListService.getSelectedAction().subscribe(
      (selectedRequestFromSubject: RequestBasicInfoResultEntity) => {
        this.requestsService.addToEditModeList(selectedRequestFromSubject.requestNumber);
        if (selectedRequestFromSubject.requestNumber === this.requestNumber) {
          this.selectedAction = selectedRequestFromSubject.action;
        }
    });
  }

  attachmentDetails(requestAttachment: RequestAttachment) {
    this.attachmentIsLoading = true;
    this.downloadAttachment(requestAttachment.attachmentId,
      (requestAttachment.attachmentType === 1) ? 'GroupAttachment' : 'IncidentAttachment',
      this.requestDetailResponse.requestInfo.requestNumber);
  }

  downloadAttachment(attachmentId: number, attachmentParentType: String, parentEntityId: number) {
    const downloadRequest = new HttpRequest('GET', CommonConstants.SERVICE_VERSION_PATH_V1 + '/file/download/' + attachmentId +
    '?attachmentParentType=' + attachmentParentType + '&parentEntityId=' + parentEntityId, {
        responseType: 'blob'
    });

    this.http.request(downloadRequest).subscribe(
        (event: HttpEvent < any > ) => {
            if (event) {
                switch (event.type) {
                    case HttpEventType.ResponseHeader:
                        let contentDispositionHeader = event.headers.get('Content-Disposition');
                        contentDispositionHeader = contentDispositionHeader.substr(22, (contentDispositionHeader.length - 1));
                        console.log(contentDispositionHeader); // Always null here although I expected it to be there.
                        break;

                    case HttpEventType.Response:
                        let contentDispositionHeader2 = event.headers.get('Content-Disposition');
                        contentDispositionHeader2 = contentDispositionHeader2.substr(22, (contentDispositionHeader2.length - 23));
                        const downloadedFile: Blob = event.body;
                        this.attachmentIsLoading = false;
                        FileSaver.saveAs(downloadedFile, contentDispositionHeader2);
                        break;
                }
            }
          },
        err => console.log(err.error)
    );
}
showKbaPage( request: RequestInfo): string {
       return  request.requestNumber + '/selfhelp/kba/' + request.solutionId;
}

increaseSolutionViewCount(requestNumber: number) {
  this.requestDetailService.increaseSolutionViewCount(requestNumber).subscribe();
 }

 viewRequestSolutionString(isSolutionWorkaround: boolean): string {
   if (isSolutionWorkaround) {
    return 'RequestDetail.viewWorkaround';
   }
   return 'RequestDetail.viewSolution';
 }

 scrollEndForCustomerSearch() {
  let s = $('#requestdetail-search-list').prop('scrollHeight');
  let s1 = $('#requestdetail-search-list').scrollTop() + $('#requestdetail-search-list').height();
  if ((s / 2) < s1) {
    if ( this.userSearchCurrentDisplayedCount < this.ccUserSearchResultCount) {
      this.usersLoading = true;
      this.userSearchOffset = this.userSearchOffset + 1;
      this.userSearchLimit = 10;
      this.userSearchCurrentDisplayedCount = this.ccUserSearchResultCount;
      this.requestDetailService.findUser(this.userSearchTerm, this.userSearchOffset, this.userSearchLimit)
      .pipe(debounceTime(400)
        , distinctUntilChanged()
        ).subscribe((resp) => {
          this.usersLoading = false;
          this.ccUserSearchResultCount = resp.resultCount;
          let temp = this.userSearchInfo.results;
          temp = temp.concat(resp.results);
          this.userSearchInfo = resp;
          this.userSearchInfo.results = temp;
          this.userSearchCurrentDisplayedCount = this.userSearchInfo.results.length;
        });
     }
  }
}

}
